import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function HowToUse() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("How to Use a B-Yosef")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("How to Use a B-Yosef")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[30px]">
                    <div className="w-[100%] shadow-md px-5 py-2 rounded">
                        <div className="capitalize">
                            {/* <div className="font-bold text-[#017E89]">{t("Cleanse Your Face")}</div> */}
                            <div>{t("Contains Thiamine (B1), Pyridoxine (B6), and Cyanocobalamin (B12).")}</div>
                            {/* <div>{t("Pat your skin dry with a clean towel.")}</div>
                            <div>{t("Apply the Mud Mask")}</div> */}
                        </div>
                    </div>
                    <div className="w-[100%] shadow-md px-5 py-2 rounded">
                        <div className="capitalize">
                            <div>{t("Supports nerve function and helps in management of neuropathies.")}</div>
                            {/* <div>{t("Avoid the delicate areas around your eyes and lips.")}</div>
                            <div>{t("Let It Dry")}</div> */}
                        </div>
                    </div>
                    <div className="w-[100%] shadow-md px-5 py-2 rounded">
                        <div className="capitalize">
                            <div>{t("Enhances energy metabolism and reduces fatigue.")}</div>
                            {/* <div>{t("If you have dry or sensitive skin, don’t let it dry completely to avoid over-drying.")}</div>
                            <div>{t("ARinse Off")}</div> */}
                        </div>
                    </div>
                    <div className="w-[100%] shadow-md px-5 py-2 rounded">
                        <div className="capitalize">
                            {t("Promotes red blood cell formation and healthy nervous system.")}
                        </div>
                    </div>
                    <div className="w-[100%] shadow-md px-5 py-2 rounded">
                        <div className="capitalize">
                            <div className="font-bold text-[#017E89]">{t("How Often to Use a B-Yosef")}</div>
                            <ul>
                                <li>{t("Commonly used for sciatica, neuritis, neuralgia, and peripheral neuropathy.")}</li>
                                <li>{t("Usually given by intramuscular injection.")}</li>
                                <li>{t("Stored at room temperature, protected from light.")}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}